import React from "react";
import ReactDom from 'react-dom/client'
import App from "./App";
const a=ReactDom.createRoot(document.getElementById("root"))

a.render(
  <div>
    <App></App>
  </div>
)